import type { NavItem } from '@/lib/navigation'

/** A nav label as rendered: `<span lang="ja">司令室</span> Shireishitsu`, or the plain label (plans/09 5.3). */
export function NavItemLabel({ item }: { item: Pick<NavItem, 'label' | 'labelJa'> }) {
  if (!item.labelJa) return <>{item.label}</>
  return (
    <>
      <span lang='ja'>{item.labelJa}</span> {item.label}
    </>
  )
}
